import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Step from '@material-ui/core/Step';
import Stepper from '@material-ui/core/Stepper';
import StepConnector from '@material-ui/core/StepConnector';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Description from '@material-ui/icons/Description';
import Spellcheck from '@material-ui/icons/Spellcheck';
import Check from '@material-ui/icons/Check';
import Assignment from '@material-ui/icons/Assignment';

import SendingStandardReportModalSuccess from '../../../../components/admin/sent/modal'
import SomethingWentWrongModal from '@components/users/standard-report-validation/something-went-wrong-modal'
import { convertNumber } from 'utils/convertExcelNumber'
import { useParams } from 'react-router-dom'
import getStepContent from '../../../../components/admin/sent'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useStoreRehydrated, useStoreState } from '../../../../store'
import { datasetRecord } from '../../../../api'
import { useLoaded } from '../../../../utils/useLoaded'
import { toThaiDateString } from '../../../../utils/thaiDate'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
	},
	button: {
		marginRight: theme.spacing(1),
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	non_approve_button: {
		backgroundColor: '#c33939',
		color: 'white',
		'&:hover': {
			backgroundColor: '#a33e3e',
		},
	},
}))

const Connector = withStyles({
	alternativeLabel: {
		top: 22,
	},
	active: {
		'& $line': {
			backgroundColor: '#a74345',
		},
	},
	completed: {
		'& $line': {
			backgroundColor: '#a74345',
		},
	},
	line: {
		height: 3,
		border: 0,
		backgroundColor: '#eaeaf0',
		borderRadius: 1,
	},
})(StepConnector)

const useStepStyles = makeStyles({
	root: {
		backgroundColor: '#ccc',
		zIndex: 1,
		color: '#fff',
		width: 50,
		height: 50,
		display: 'flex',
		borderRadius: '50%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	active: {
		backgroundColor: '#a74345',
		boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
	},
	completed: {
		backgroundColor: '#a74345',
	},
})

function getSteps() {
	return ['รายละเอียดการส่ง', 'รายละเอียดรายงาน']
}

export default function StandardReportValidationDetails({ match }) {
	const isReHydrated = useStoreRehydrated()
	const admin = useStoreState(s => s.QoSAdminModel.admin)
	const history = useHistory()
	const { id } = useParams()
	const classes = useStyles()
	const steps = getSteps()
	const [activeStep, setActiveStep] = useState(0)
	const [openStandardReportSuccessModal, setOpenStandardReportSuccessModal] =
		useState(false)
	// Type of Standard Report
	const [reportTypes, setReportTypes] = useState([])
	// Current Page of Required Filled Standard Report Form
	const [currentFilledFormIndex, setCurrentFilledFormIndex] = useState(0)
	// Standard Report Form Answers
	const [fixedGeneralAnswers, setFixedGeneralAnswers] = useState([])
	const [fixedInfoAnswers, setFixedInfoAnswers] = useState([])
	const [fixedSoundAnswers, setFixedSoundAnswers] = useState([])
	const [mobileGeneralAnswers, setMobileGeneralAnswers] = useState([])
	const [mobileInfoAnswers, setMobileInfoAnswers] = useState([])
	const [mobileSoundAnswers, setMobileSoundAnswers] = useState([])
	const loaded = useLoaded()
	const [dataSetFilesUpload, setDataSetFilesUpload] = useState([])
	const [openSomethingWentWrongModal, setSomethingWentWrongModal] =
		useState(false)
	const [currentSelectedError, setCurrentSelectedError] = useState({
		dataSetItemID: '',
		reason: '',
		solution: '',
		periodSolution: '',
		validateFileUrl: null,
	})
	const [openValidationModal, setOpenValidationModal] = useState(false)
	const [reportVersion, setReportVersion] = useState(2)

	const [operatorFlag, setOperatorFlag] = useState({
		isPayphone: false,
		isNVMO: false,
		is2G: false,
		isUseReport1_1_2: false,
	})

	/** ---------------------------------------------- */

	/**  Main Handler Function */

	const onOpenStandardReportSuccessModal = () =>
		setOpenStandardReportSuccessModal(!openStandardReportSuccessModal)

	const onAgreeStandardReportSuccessModalCTA = () => {
		onOpenStandardReportSuccessModal()
		history.push({
			pathname: '/admin/standard-report',
		})
	}

	const handleNext = () => {
		setActiveStep(prevActiveStep => prevActiveStep + 1)
	}

	const handleBack = () => {
		if (activeStep === 0) history.push('/admin/sent')
		else setActiveStep(prevActiveStep => prevActiveStep - 1)
	}

	const changeStatusReportHead = async () => {
		const { status } = await datasetRecord.changeStatusReportHeadAdmin(id, 5)
		if (status === 200) onOpenStandardReportSuccessModal()
	}

	const handleCancelReport = () => {
		Swal.fire({
			title: 'ยืนยันการยกเลิกรายงาน?',
			text: "คุณต้องการยกเลิกรายงานนี้ใช่หรือไม่",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'ยืนยัน',
			cancelButtonText: 'ยกเลิก',
			// reverseButtons: true
		}).then(async (result) => {
			if (result.isConfirmed) {
				const res = await datasetRecord.changeStatusReportHeadAdmin(id, 1);
				if (res && res.status === 200) {
					Swal.fire(
						'ยกเลิกสำเร็จ!',
						'รายงานถูกยกเลิกและเปลี่ยนสถานะเป็นรอตรวจสอบเรียบร้อยแล้ว',
						'success'
					).then(() => {
						history.push('/admin/sent')
					})
				} else {
					Swal.fire(
						'เกิดข้อผิดพลาด!',
						'ไม่สามารถยกเลิกรายงานได้',
						'error'
					)
				}
			}
		})
	}

	function StepperIcon(props) {
		const classes = useStepStyles()
		const { active, completed } = props

		const icons = {
			1: <Assignment />,
			2: <Description />,
			3: <Spellcheck />,
		}

		return (
			<div
				className={clsx(classes.root, {
					[classes.active]: active,
					[classes.completed]: completed,
				})}>
				{completed ? <Check /> : icons[String(props.icon)]}
			</div>
		)
	}

	StepperIcon.propTypes = {
		active: PropTypes.bool,
		completed: PropTypes.bool,
		icon: PropTypes.node,
	}

	const [rowData, setRowData] = useState([])

	const onLanding = useCallback(async () => {
		const res = await datasetRecord.getListDetailsAdmin(id)

		const tempFixedGeneralAnswers = []
		const tempFixedSoundAnswers = []
		const tempFixedInfoAnswers = []
		const tempMobileGeneralAnswers = []
		const tempMobileSoundAnswers = []
		const tempMobileInfoAnswers = []

		/**
		 * Answer Object Example:
		 *    {
		 *    	dataSetItemID: Integer,
		 *      dataValueMonth1: String,
		 *      dataValueMonth2: String,
		 *      dataValueMonth3: String,
		 *      dataValueMonthAvg: String,
		 *    }
		 */
		if (res) {
			var formVersion = res.info.formVersion ? res.info.formVersion : '1'
			setReportVersion(formVersion)

			setOperatorFlag({
				isPayphone: res.info.isPayphone == 'y' ? true : false,
				isNVMO: res.info.isNVMO == 'y' ? true : false,
				is2G: res.info.is2G == 'y' ? true : false,
				isUseReport1_1_2: res.info.isUseReport1_1_2,
			})

			// ANSWERS

			res.data.forEach(item => {
				const newitem = {
					...item, dataSetItemID: item.dataSetItemID,
					dataValueMonth1: item.dataValueMonth1 ? convertNumber(item.dataValueMonth1, true) : '',
					dataValueMonth2: item.dataValueMonth2 ? convertNumber(item.dataValueMonth2, true) : '',
					dataValueMonth3: item.dataValueMonth3 ? convertNumber(item.dataValueMonth3, true) : '',
					dataValueMonthAvg: item.dataValueMonthAvg ? convertNumber(item.dataValueMonthAvg, true) : ''
				}

				if (formVersion === '1' || formVersion === 1) {
					if (item.dataSetItemID <= 10)
						tempFixedGeneralAnswers.push(newitem);
					else if (item.dataSetItemID <= 20)
						tempFixedSoundAnswers.push(newitem);
					else if (item.dataSetItemID <= 30)
						tempFixedInfoAnswers.push(newitem);
					else if (item.dataSetItemID <= 40)
						tempMobileGeneralAnswers.push(newitem);
					else if (item.dataSetItemID <= 200)
						tempMobileSoundAnswers.push(newitem);
					else if (item.dataSetItemID > 200)
						tempMobileInfoAnswers.push(newitem);
				} else if (formVersion === '2' || formVersion === 2) {
					if (item.dataSetItemID <= 11999) tempFixedGeneralAnswers.push(newitem)
					else if (item.dataSetItemID <= 12999) tempFixedSoundAnswers.push(newitem)
					else if (item.dataSetItemID <= 13999) tempFixedInfoAnswers.push(newitem)
					else if (item.dataSetItemID <= 21999)
						tempMobileGeneralAnswers.push(newitem)
					else if (item.dataSetItemID <= 22999) tempMobileSoundAnswers.push(newitem)
					else if (item.dataSetItemID > 22999) tempMobileInfoAnswers.push(newitem)
				}

			})

			let tempReportTypes = []

			if (tempFixedGeneralAnswers.length !== 0)
				tempReportTypes.push('fixed-general')

			if (tempFixedSoundAnswers.length !== 0 && res.info.isUseReport1_1_2)
				tempReportTypes.push('fixed-sound')

			if (tempFixedInfoAnswers.length !== 0) tempReportTypes.push('fixed-info')

			if (tempMobileGeneralAnswers.length !== 0)
				tempReportTypes.push('mobile-general')

			if (tempMobileSoundAnswers.length !== 0)
				tempReportTypes.push('mobile-sound')

			if (tempMobileInfoAnswers.length !== 0)
				tempReportTypes.push('mobile-info')

			// setFormAmount(tempFormAmount)
			setReportTypes(tempReportTypes)

			setFixedGeneralAnswers(tempFixedGeneralAnswers)
			setFixedSoundAnswers(tempFixedSoundAnswers)
			setFixedInfoAnswers(tempFixedInfoAnswers)
			setMobileGeneralAnswers(tempMobileGeneralAnswers)
			setMobileSoundAnswers(tempMobileSoundAnswers)
			setMobileInfoAnswers(tempMobileInfoAnswers)

			// DATA SET FILES UPLOAD
			const tempFiles = []

			res.files.forEach(file => {
				if (!tempFiles[file.category]) tempFiles[file.category] = []

				tempFiles[file.category].push(file)
			})

			if (res?.files?.length === 0 && res?.data?.length === 0)
				setSomethingWentWrongModal(true)

			setDataSetFilesUpload(tempFiles)

			let rowDataTemp = {
				name: res.info.admin
					? `(เจ้าหน้าที่) ${res.info.admin.firstname} ${res.info.admin.lastname}`
					: res.info.operatorUserName,
				companyName: res.info.operatorName,
				submit_date: toThaiDateString(res.info.sendToAdminAt),
				status: res.info.status,
				dataTypeList: res.info.reportType,
				admin: res.info.admin,
				quarter: res.info.quarter || res.info.Quarter,
			}
			setRowData(rowDataTemp)
		}
	}, [id])

	/** ---------------------------------------------- */

	/** Step 2 */

	const onIncrementCurrentFilledFormIndex = () =>
		setCurrentFilledFormIndex(currentFilledFormIndex + 1)

	const onDecrementCurrentFilledFormIndex = () =>
		setCurrentFilledFormIndex(currentFilledFormIndex - 1)

	const onOpenValidationModal = (
		dataSetItemID,
		reason,
		solution,
		periodSolution,
		validateFileUrl
	) => {
		setCurrentSelectedError({
			dataSetItemID,
			reason,
			solution,
			periodSolution,
			validateFileUrl,
		})

		setOpenValidationModal(true)
	}

	const onCloseValidationModal = () => setOpenValidationModal(false)

	/** ---------------------------------------------- */

	/**  Main Rendering */

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	useEffect(() => {
		if (isReHydrated) onLanding()
		// eslint-disable-next-line
	}, [isReHydrated])

	/** ---------------------------------------------- */

	return (
		loaded && (
			<>
				<Grid className="min-h-screen flex flex-col pb-10 px-2 lg:px-10">
					<Grid className={`${classes.root} h-full`}>
						<Stepper
							style={{ backgroundColor: 'transparent' }}
							alternativeLabel
							activeStep={activeStep}
							connector={<Connector />}>
							{steps.map((label, index) => (
								<Step alternativeLabel key={label + index}>
									<StepLabel StepIconComponent={StepperIcon}>{label}</StepLabel>
								</Step>
							))}
						</Stepper>
						<Grid>
							{activeStep === steps.length ? (
								<Grid>
									<Typography className={classes.instructions}>
										All steps completed - you&apos;re finished
									</Typography>
								</Grid>
							) : (
								<Grid
									container
									direction="row"
									justifyContent="center"
									className="pb-14 ">
									<Grid container item>
										<Grid
											className={`${classes.instructions} w-full pb-4`}
											component="div">
											{admin?.id === 17 && (
												<Grid className="flex justify-end mb-4">
													<Button
														onClick={handleCancelReport}
														variant="contained"
														color="secondary"
														className={`${classes.non_approve_button} w-36`}>
														ยกเลิกรายงาน
													</Button>
												</Grid>
											)}
											{getStepContent(
												activeStep,
												rowData,
												// Standard Report State,
												reportTypes,
												currentFilledFormIndex,
												// Standard Report Answers
												fixedGeneralAnswers,
												fixedInfoAnswers,
												fixedSoundAnswers,
												mobileGeneralAnswers,
												mobileInfoAnswers,
												mobileSoundAnswers,
												dataSetFilesUpload,
												// Validation
												currentSelectedError,
												openValidationModal,
												onOpenValidationModal,
												onCloseValidationModal,
												// version
												reportVersion,
												operatorFlag,
											)}
										</Grid>
									</Grid>
									<Grid
										container
										item
										direction="row"
										justifyContent="space-between"
										alignItems="baseline"
										className="w-full">
										<Grid item>
											<Button
												onClick={() => {
													if (activeStep === 1 && currentFilledFormIndex !== 0)
														onDecrementCurrentFilledFormIndex()
													else handleBack()
												}}
												variant="contained"
												className="w-36">
												ย้อนกลับ
											</Button>
										</Grid>

										<Grid item>
											<Button
												variant="contained"
												color="secondary"
												disabled={
													currentFilledFormIndex === reportTypes.length - 1
												}
												onClick={() => {
													if (activeStep === 2) {
														// onOpenStandardReportSuccessModal()
														changeStatusReportHead(id, 3)
													} else {
														if (
															activeStep === 1 &&
															currentFilledFormIndex < reportTypes.length - 1
														)
															onIncrementCurrentFilledFormIndex()
														else if (activeStep !== steps.length - 1)
															handleNext()
													}
												}}
												className={`w-36`}>
												<>
													{activeStep !== steps.length - 1
														? activeStep === 0
															? 'ถัดไป'
															: 'รายงานถัดไป'
														: 'ถัดไป'}
												</>
											</Button>
										</Grid>
									</Grid>
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>

				<SendingStandardReportModalSuccess
					open={openStandardReportSuccessModal}
					handleButton={onAgreeStandardReportSuccessModalCTA}
				/>
				<SomethingWentWrongModal
					open={openSomethingWentWrongModal}
					handleButton={() => history.goBack()}
				/>
			</>
		)
	)
}
